<template>
	<div class="content">

		<div class="md-layout">
			<div class="md-layout-item md-medium-size-100 md-size-100">

				<md-card>
					<md-card-header data-background-color="purple">
						<h4 class="title">បង្កើតរំលោះថ្មី</h4>
					</md-card-header>
					<md-card-content>
						<loading v-if="!loaded"/>
						<div class="md-layout" v-if="loaded">
							<div class="md-layout-item md-small-size-100 md-size-50">
								<div class="md-layout-item md-small-size-100 md-size-100">
									<h3>ព័ត៌មានអំពីរំលោះ</h3>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-100 text-right">
									<span class="late">* តម្រូវបំពេញ</span>
								</div>
								<div class="md-layout">

									<div class="md-layout-item md-small-size-100 md-size-50">
										<label>ទីតាំងគម្រោង *</label>
										<v-select label="name" inputId="id" :clearable="false" :options="projectList"
											v-model="loan.projectArray">
										</v-select>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-50">
										<md-field>
											<label>លេខឡូតិ៍ *</label>
											<md-input type="text" v-model="loan.lot" @keyup="clearPayment()"></md-input>
										</md-field>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-50">
										<md-field>
											<label>តម្លៃបង់រំលោះ *</label>
											<md-input type="number" v-model="loan.amount" @keyup="clearPayment()"></md-input>
										</md-field>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-50">
										<md-field>
											<label>ទឹកប្រាក់កក់មុន *</label>
											<md-input type="number" v-model="loan.deposit" @keyup="clearPayment()"></md-input>
										</md-field>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-50">
										<md-field>
											<label>ថ្ងៃកក់ប្រាក់</label>
											<md-input type="text" v-model="loan.deposit_date_prototype" style="display:none" />
											<datetime type="date" v-model="loan.deposit_date_prototype" auto value-zone="UTC+7"></datetime>
										</md-field>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-50">
										<md-field>
											<label>ថ្ងៃបង់រំលោះបន្ទាប់</label>
											<md-input type="text" v-model="loan.start_date_prototype" style="display:none" />
											<datetime type="date" v-model="loan.start_date_prototype" auto value-zone="UTC+7"></datetime>
										</md-field>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-50">
										<md-field>
											<label>ចំនួនខែបង់ជាដំណាក់កាល *</label>
											<md-input type="number" v-model="loan.total_month_step" @keyup="clearPayment()"></md-input>
										</md-field>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-50">
										<md-field>
											<label>ទឹកប្រាក់បង់ជាដំណាក់កាល *</label>
											<md-input type="number" v-model="loan.total_payment_step" @keyup="clearPayment()"></md-input>
										</md-field>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-50">
										<md-field>
											<label>ចំនួនខែរំលោះគ្មានការប្រាក់ *</label>
											<md-input type="number" v-model="loan.total_month_no_interest" @keyup="clearPayment()"></md-input>
										</md-field>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-50">
										<md-field>
											<label>ទឹកប្រាក់បង់ប្រចាំខែគ្មានការប្រាក់ *</label>
											<md-input type="number" v-model="loan.total_payment_no_interest" @keyup="clearPayment()"></md-input>
										</md-field>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-50">
										<md-field>
											<label>ចំនួនខែរំលោះមានការប្រាក់ *</label>
											<md-input type="number" v-model="loan.total_month_interest" @keyup="clearPayment()"></md-input>
										</md-field>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-50">
										<md-field>
											<label>ការប្រាក់ប្រចាំឆ្នាំ *</label>
											<md-input type="number" v-model="loan.interest" @keyup="clearPayment()"></md-input>
										</md-field>
									</div>

									<div class="md-layout-item md-small-size-100 md-size-100">
										<md-field>
											<label>កំណត់ចំណាំ</label>
											<md-input type="text" v-model="loan.note"></md-input>
										</md-field>
									</div>
									<!-- <div class="md-layout-item md-size-100 text-right">
										<md-button :class="{'md-raised': true, 'md-primary': loan.valid}" :disabled="!loan.valid" @click="">
											Preview</md-button>
									</div> -->
								</div>

								<div class="md-layout-item md-small-size-100 md-size-100">
									<h3>អតិថិជន</h3>
									<div class="md-layout">
										<div class="md-layout-item md-small-size-70 md-size-70">
											<md-field>
												<label>ស្វែងរកអតិថិជនដោយឈ្មោះ លេខទូរស័ព្ទ ឬ លេខកូដ</label>
												<md-input type="text" v-model="search.text" @keyup.enter="searchClient()">
												</md-input>
											</md-field>
										</div>
										<div class="md-layout-item md-small-size-30 md-size-30">
											<md-button class="md-raised md-primary" @click="searchClient()" style="width: 100%">ស្វែងរក
											</md-button>
										</div>
										<div class="md-layout-item md-small-size-100 md-size-100">
											<md-table>
												<md-table-row v-for="(client, index) in search.clientList.slice(0, 5)">
													<md-table-cell>
														<!-- <img src="@/assets/img/default-member.png" style="width: 34px; margin-right:5px"> -->
														<b>ID: {{client.hash}}</b> ({{client.name}}, {{client.phone}})
													</md-table-cell>
													<md-table-cell class=" text-right">
														<md-button class="md-just-icon md-simple md-success" @click="addClient(client)">
															<md-icon>add</md-icon>
															<md-tooltip md-direction="top">ភ្ជាប់អតិថិជននេះ</md-tooltip>
														</md-button>
													</md-table-cell>
												</md-table-row>
											</md-table>
										</div>
									</div>
								</div>

							</div>
							<div class="md-layout-item md-small-size-100 md-size-50">
								<div class="md-layout-item md-small-size-100 md-size-100">
									<h3>ព័ត៌មានសង្ខេប</h3>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-100">
									<md-table>

										<md-table-row>
											<md-table-cell style="width: 40%;">អតិថិជន</md-table-cell>
											<md-table-cell style="width: 5px">:</md-table-cell>
											<md-table-cell>

												<span v-if="String(loan.client_id).length > 0"
													style="display: flex;align-items: center;justify-content: space-between;width: 100%;">
													<span><b>ID: {{loan.client[0].hash}}</b> ({{loan.client[0].name}})</span>
													<md-button class="md-just-icon md-simple md-danger" @click="removeClient()">
														<md-icon>remove</md-icon>
														<md-tooltip md-direction="top">លុបចេញ</md-tooltip>
													</md-button>
												</span>
												<span v-else>មិនទាន់មាន</span>

											</md-table-cell>
										</md-table-row>
										<md-table-row>
											<md-table-cell>ទីតាំងគម្រោង</md-table-cell>
											<md-table-cell>:</md-table-cell>
											<md-table-cell>
												<span v-if="String(loan.project).length > 0">{{loan.project}}</span>
												<span v-else>មិនទាន់មាន</span>
											</md-table-cell>
										</md-table-row>
										<md-table-row>
											<md-table-cell>លេខឡូតិ៍</md-table-cell>
											<md-table-cell>:</md-table-cell>
											<md-table-cell>
												<span v-if="String(loan.lot).length > 0">{{loan.lot}}</span>
												<span v-else>មិនទាន់មាន</span>
											</md-table-cell>
										</md-table-row>
										<md-table-row>
											<md-table-cell>តម្លៃបង់រំលោះ</md-table-cell>
											<md-table-cell>:</md-table-cell>
											<md-table-cell>
												<span v-if="String(loan.amount).length > 0">{{config.moneylify(loan.amount)}}</span>
												<span v-else>មិនទាន់មាន</span>
											</md-table-cell>
										</md-table-row>
										<md-table-row>
											<md-table-cell>ទឹកប្រាក់កក់មុន</md-table-cell>
											<md-table-cell>:</md-table-cell>
											<md-table-cell>
												<span v-if="String(loan.deposit).length > 0">{{config.moneylify(loan.deposit)}}</span>
												<span v-else>មិនទាន់មាន</span>
											</md-table-cell>
										</md-table-row>
										<md-table-row>
											<md-table-cell>រយៈពេលបង់ជាដំណាក់កាល</md-table-cell>
											<md-table-cell>:</md-table-cell>
											<md-table-cell>
												<span v-if="String(loan.total_month_step).length > 0">{{loan.total_month_step}} ខែ</span>
												<span v-else>មិនទាន់មាន</span>
											</md-table-cell>
										</md-table-row>
										<md-table-row>
											<md-table-cell>បង់ប្រចាំខែជាដំណាក់កាល</md-table-cell>
											<md-table-cell>:</md-table-cell>
											<md-table-cell>
												<span v-if="String(loan.total_payment_step).length > 0">{{config.moneylify(loan.total_payment_step)}}</span>
												<span v-else>មិនទាន់មាន</span>
											</md-table-cell>
										</md-table-row>
										<md-table-row>
											<md-table-cell>រយៈពេលរំលោះគ្មានការប្រាក់</md-table-cell>
											<md-table-cell>:</md-table-cell>
											<md-table-cell>
												<span v-if="String(loan.total_month_no_interest).length > 0">{{loan.total_month_no_interest}} ខែ</span>
												<span v-else>មិនទាន់មាន</span>
											</md-table-cell>
										</md-table-row>
										<md-table-row>
											<md-table-cell>បង់ប្រចាំខែគ្មានការប្រាក់</md-table-cell>
											<md-table-cell>:</md-table-cell>
											<md-table-cell>
												<span v-if="String(loan.total_payment_no_interest).length > 0">{{config.moneylify(loan.total_payment_no_interest)}}</span>
												<span v-else>មិនទាន់មាន</span>
											</md-table-cell>
										</md-table-row>
										<md-table-row>
											<md-table-cell>រយៈពេលរំលោះមានការប្រាក់</md-table-cell>
											<md-table-cell>:</md-table-cell>
											<md-table-cell>
												<span v-if="String(loan.total_month_interest).length > 0">{{loan.total_month_interest}} ខែ</span>
												<span v-else>មិនទាន់មាន</span>
											</md-table-cell>
										</md-table-row>
										<md-table-row>
											<md-table-cell>ការប្រាក់ប្រចាំឆ្នាំ</md-table-cell>
											<md-table-cell>:</md-table-cell>
											<md-table-cell>
												<span v-if="String(loan.interest).length > 0">{{loan.interest}}% (per annual)</span>
												<span v-else>មិនទាន់មាន</span>
											</md-table-cell>
										</md-table-row>
									</md-table>
								</div>
							</div>

							<div class="md-layout-item md-size-100 text-right">
								<md-button class="md-raised md-primary" @click="calculateLoan()">បង្ហាញតារាងរំលោះ</md-button>
								<md-button class="md-raised md-primary" @click="createLoan()">បង្កើត</md-button>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-100" v-if="loan.payment.length > 0">
								<h3>តារាងបង់រំលោះ</h3>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-100" v-if="loan.payment.length > 0">
								<md-table>
									<md-table-row>
										<md-table-head>ល.រ</md-table-head>
										<md-table-head>ថ្ងៃបង់ប្រាក់</md-table-head>
										<md-table-head>ប្រាក់ដើម</md-table-head>
										<md-table-head>ការប្រាក់</md-table-head>
										<md-table-head>ទឹកប្រាក់ត្រូវបង់</md-table-head>
										<md-table-head>ទឹកប្រាក់នៅសល់</md-table-head>
									</md-table-row>
									<md-table-row v-for="(payment, index) in loan.payment">
										<md-table-cell>{{index}}</md-table-cell>
										<md-table-cell>{{payment[4]}}</md-table-cell>
										<md-table-cell>{{config.moneylify(payment[1])}}</md-table-cell>
										<md-table-cell>{{config.moneylify(payment[2])}}</md-table-cell>
										<md-table-cell><b>{{config.moneylify(parseFloat(payment[1]) + parseFloat(payment[2]))}}</b></md-table-cell>
										<md-table-cell>{{config.moneylify(payment[3])}}</md-table-cell>
									</md-table-row>
								</md-table>
							</div>
						</div>
					</md-card-content>
				</md-card>
			</div>
		</div>
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchProject();
		},

		data() {
			return {
				loaded: false,
				loadMore: false,
				deleteDialogActive: false,
				deleteSelected: '',
				search: {
					clientList: [],
					type: "",
					text: "",
					status: ""
				},
				loan: {
					start_date_prototype: "",
					start_date: "",
					deposit_date_prototype: "",
					deposit_date: "",
					lot: "",
					amount: "",
					interest: "",
					total_month_interest: "",
					deposit: "",
					total_month_step: "",
					total_payment_step: "",
					total_month_no_interest: "",
					total_payment_no_interest: "",
					note: "",
					client_id: "",
					client: [],
					payment: [],
					project: "",
					project_id: "",
					projectArray: ""
				},
				loadMore: true,
				loanList: [],
				projectList: []

			}
		},
		watch: {
			'loan.projectArray': function (val) {
				if (String(this.loan.projectArray).length > 5) {
					this.loan.project_id = this.loan.projectArray.id;
					this.loan.project = this.loan.projectArray.name;
				} else {
					this.loan.project_id = "";
					this.loan.project = "";
				}
			},
		},
		methods: {
			createLoan() {
				console.log(this.loan.start_date_prototype);
				console.log((new Date(this.loan.start_date_prototype)).getTime());

				if (String(this.loan.amount).length > 0 &&
				String(this.loan.lot).length > 0 &&
				String(this.loan.start_date_prototype).length > 0 &&
				String(this.loan.deposit_date_prototype).length > 0 &&
				String(this.loan.project_id).length > 0 &&
				String(this.loan.client_id).length > 0) {
					this.loan.start_date = (new Date(this.loan.start_date_prototype)).getTime();
					this.loan.deposit_date = (new Date(this.loan.deposit_date_prototype)).getTime();
					this.$http.post(this.config.api + "/admin/loan/post", {
						loan: this.loan,
					}).then(data => {
						if (data.body.status == 'success') {
							this.$notification.notify({
								message: "រំលោះត្រូវបានបង្កើតឡើងដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							});
							this.$router.push("/loans/detail/" + data.body.data.hash);
						}
					})
				} else {
					this.$notification.notify({
							message: "សូមបំពេញព័ត៌មានអោយបានត្រឹមត្រូវ",
							icon: 'error',
							type: 'danger'
					})
				}
			},
			calculateLoan() {
				this.loan.payment = [];
				if (
				String(this.loan.amount).length > 0 &&
				String(this.loan.deposit).length > 0 &&
				String(this.loan.start_date_prototype).length > 0 &&
				String(this.loan.deposit_date_prototype).length > 0
				) {

					let amount = parseFloat(this.loan.amount) || 0;
					let deposit = parseFloat(this.loan.deposit) || 0;

					let total_month_step = parseInt(this.loan.total_month_step) || 0;
					let total_payment_step = parseFloat(this.loan.total_payment_step) || 0;

					let total_month_no_interest = parseInt(this.loan.total_month_no_interest) || 0;
					let total_payment_no_interest = parseFloat(this.loan.total_payment_no_interest) || 0;

					let total_month_interest = parseInt(this.loan.total_month_interest) || 0;
					let interest = parseFloat(this.loan.interest) || 0;

					let deposit_payment_date = parseInt((new Date(this.loan.deposit_date_prototype)).getTime());
					let start_payment_date = parseInt((new Date(this.loan.start_date_prototype)).getTime());

					let payments = [];
					let t = 0;

				// initial deposit payment
					amount = amount - deposit;
					payments.push([t, deposit, 0, amount, this.config.getPaymentDate(deposit_payment_date, 0)]);

				// step payment
					if(parseInt(total_month_step) > 0 && parseFloat(total_payment_step) > 0) {

						for(let i =0; i< total_month_step; i++) {
							amount = amount - total_payment_step;
							payments.push([t, total_payment_step, 0, amount, this.config.getPaymentDate(start_payment_date, t)]);
							t++;
						}
					}

					// no interest payment
					if(parseInt(total_month_no_interest) > 0 && parseFloat(total_payment_no_interest) > 0) {

						for(let i =0; i< total_month_no_interest; i++) {
							amount = amount - total_payment_no_interest;
							payments.push([t, total_payment_no_interest, 0, amount, this.config.getPaymentDate(start_payment_date, t)]);
							t++;
						}
					}

					// interest payment
					if(parseInt(total_month_interest) > 0 && parseFloat(interest) > 0) {
						let monthly_interest = (interest / 100) / 12;
						let payment = parseFloat(amount * (monthly_interest/(1-Math.pow(1+monthly_interest, -1 * total_month_interest)))).toFixed(3);

						for(let i = 0; i < total_month_interest; i++) {
							let payment_interest = (amount * monthly_interest * 10 / 10).toFixed(3);
							let principal = 0;
							if(total_month_interest == i + 1) {
								principal = amount;
							} else {
								principal = parseFloat(payment - payment_interest).toFixed(3);
							}
							amount = parseFloat(amount - principal).toFixed(3);
							payments.push([t, principal, payment_interest, amount, this.config.getPaymentDate(start_payment_date, t)]);
							t++;
						}
					}

					let last_payments = payments.length - 1;
					if(payments[last_payments][3] != 0) {
						payments[last_payments][1] = payments[last_payments][1] + payments[last_payments][3];
						payments[last_payments][3] = 0;
					}

					this.loan.payment = payments;

				} else {
					this.loan.payment = [];
				}
			},
			searchProject() {
				this.$http.post(this.config.api + "/admin/project/search", {
					text: ""
				}).then(data => {
					this.projectList = data.body.data;
					this.loaded = true;
				})
			},
			searchClient() {
				this.$http.post(this.config.api + "/admin/client/search", {
					text: this.search.text,
					gender: ""
				}).then(data => {
					this.search.text = "";
					// this.loadMoreCompanyButton = true
					this.search.clientList = data.body.data;
				})
			},
			addClient(client) {
				this.loan.client_id = client.id;
				this.loan.client.push(client);
				this.search.clientList = []
			},
			removeClient() {
				this.loan.client_id = "";
				this.loan.client = [];
			},
			showDeleteAction(id) {
				this.deleteSelected = id
				this.deleteDialogActive = true
			},

			clearPayment() {
				this.loan.payment = [];
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/NewLoan.vue